/* This converts a js float to a german printable number */
export default function formatNumber(value: number, decimals: number): string {
  return value.toFixed(decimals).replace(".", ",");
}
